import AntCard, { type CardProps as AntCardProps } from "antd/lib/card";
import { FC } from "react";

type CardProps = AntCardProps;

export const Card: FC<CardProps> & {
    Meta: typeof AntCard.Meta;
    Grid: typeof AntCard.Grid;
} = props => {
    return <AntCard {...props} />;
};

Card.Meta = AntCard.Meta;
Card.Grid = AntCard.Grid;
